import React from 'react';
import { createComponent } from "../../../wayin-react";
var ContentCardHeader = createComponent({
  displayName: 'ContentCardHeaderCmp',
  propTypes: {},
  defaultProps: {},
  render: function render(p) {
    return /*#__PURE__*/React.createElement("div", {
      className: "content-card-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-card-header__inner"
    }, p.children));
  }
});
export default ContentCardHeader;
//# sourceMappingURL=content-card-header.js.map